module.exports = __webpack_public_path__ + "media/images/plans/img_online1-646247e1ceed8bc603d4bdc1b419eebb.jpg";